<ng-container *ngIf="canShow">
  <eds-panel
    theme="fund-header"
    edsSpacing="none"
    [hasStickyOverlap]="true"
    class="product-detail-layout__fund-header"
    [class.product-detail-layout__lit-preview]="isLitPreview"
  >
    <div edsGrid edsPadding [edsPaddingBottom]="isLitPreview ? '' : 'md'">
      <div edsRow>
        <div edsCol>
          <!-- breadcrumbs  area -->
          <eds-breadcrumbs
            [theme]="componentTheme"
            [items]="pdBreadcrumbs"
            [edsSpacing]="breadcrumbSpacing"
            edsPadding
          >
          </eds-breadcrumbs>
          <!-- /breadcrumbs  area -->
        </div>
      </div>
      <div class="container container--wide">
        <ng-container brComponent="title-content"> </ng-container>
      </div>
    </div>
  </eds-panel>

  <!-- Sticky Tabs -->
  <!-- WARNING! don't wrap <eds-tabs-sticky> in <div>s etc, as they'll stop being sticky -->
  <!-- hide sticky tabs for print -->
  <eds-tabs-sticky
    *ngIf="!isLitPreview"
    class="print-hidden"
    [links]="fundTabs"
    [activeTab]="activeTabId"
    (onTabChanged)="onTabChange($event)"
    (onHeightChanged)="onStickyTabsHeightChange($event)"
    edsSpacing="md"
    [stickyTitle]="stickyFundName"
    [scrollToTopTitle]="backToTopTitle"
    [enableScrollToTop]="true"
    [stickyNavLinks]="stickyNavLinks"
  ></eds-tabs-sticky>

  <section edsGrid *ngIf="!isLitPreview">
    <div class="container container--wide">
      <div edsRow>
        <div edsCol>
          <eds-proximal placement="ProductPageProximalTop"></eds-proximal>
        </div>
      </div>
    </div>
  </section>

  <!-- Overview -->
  <eds-panel
    [theme]="sectionsToShow.overview?.isOddSection ? 'grey' : 'basic'"
    *ngIf="sectionsToShow.overview?.display"
  >
    <section
      edsGrid
      edsSpacing="xl"
      id="overview"
      class="product-detail-layout__overview"
    >
      <div class="container container--wide">
        <div edsRow>
          <div edsCol>
            <!-- Title and Logo uses flexBox layout directive -->
            <div
              edsFlexbox
              justifyContent="space-between"
              alignItems="center"
              edsSpacing="md"
            >
              <div>
                <!-- Title -->
                <eds-section-header [level]="2" theme="primary" size="h2">
                  {{ "products.fund-tab-overview" | translate: fundId:fundId }}
                </eds-section-header>
              </div>
              <!-- Logo -->
              <div [innerHTML]="simLogo$ | async"></div>
            </div>

            <ng-container
              *ngIf="page && (isEditMode || sectionsToShow.overview?.populate)"
              brComponent="overview"
            >
            </ng-container>
            <div
              *ngIf="page && !isEditMode && !sectionsToShow.overview?.populate"
              class="product-detail-layout__skeleton-space"
            >
              <eds-progress-spinner
                [isHide]="false"
                [ifLoadingText]="true"
                [loadingText]="'products.loading' | translate"
                spinnerName="ProductOverviewSpinner"
              ></eds-progress-spinner>
            </div>
          </div>
        </div>
      </div>
    </section>
  </eds-panel>

  <!-- Performance -->
  <eds-panel
    [theme]="sectionsToShow.performance?.isOddSection ? 'grey' : 'basic'"
    *ngIf="sectionsToShow.performance?.display"
  >
    <section
      id="performance"
      class="product-detail-layout__performance"
      edsGrid
      edsSpacing="xl"
      edsPadding
      edsPaddingTop="xl"
    >
      <div class="container container--wide">
        <div edsRow>
          <div edsCol>
            <eds-title
              [title]="'products.fund-tab-performance' | translate: fundId"
              [level]="2"
              edsSpacing="lg"
              theme="primary"
              size="h2"
            ></eds-title>

            <ng-container
              *ngIf="page && isEditMode"
              brComponent="performance"
            ></ng-container>
            <ng-container *ngIf="page && !isEditMode">
              <!-- Live -->
              <ng-container *ngIf="sectionsToShow.performance?.populate">
                <eds-tabs
                  [followFocus]="true"
                  [isNavigation]="true"
                  edsPadding
                  edsPaddingBottom="lg"
                  [darkBackground]="
                    sectionsToShow.performance?.isOddSection ? true : false
                  "
                  [cacheActive]="true"
                  [fullWidth]="true"
                  dropdownTheme="handheld"
                >
                  <eds-tab
                    *ngFor="let performanceComponent of performanceComponents"
                    [tabId]="performanceComponent.tabId"
                    [heading]="
                      performanceComponent.tabLabelKey | translate: fundId
                    "
                  >
                    <ng-container
                      [brComponent]="performanceComponent"
                    ></ng-container>
                  </eds-tab>
                </eds-tabs>
              </ng-container>
              <div
                *ngIf="!sectionsToShow.performance?.populate"
                class="product-detail-layout__skeleton-space"
              >
                <eds-progress-spinner
                  [isHide]="false"
                  [ifLoadingText]="true"
                  [loadingText]="'products.loading' | translate"
                  spinnerName="ProductPerformanceSpinner"
                ></eds-progress-spinner>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </section>
  </eds-panel>

  <!-- Attribution -->
  <eds-panel
    [theme]="sectionsToShow.attribution?.isOddSection ? 'grey' : 'basic'"
    *ngIf="sectionsToShow.attribution?.display"
  >
    <section
      id="attribution"
      class="product-detail-layout__attribution"
      edsGrid
      edsSpacing="xl"
      edsPadding
      edsPaddingTop="xl"
    >
      <div class="container container--wide">
        <div edsRow>
          <div edsCol>
            <eds-title
              [title]="'products.fund-tab-attribution' | translate: fundId"
              [level]="2"
              edsSpacing="lg"
              theme="primary"
              size="h2"
            ></eds-title>

            <ng-container
              *ngIf="page && sectionsToShow.attribution?.populate"
              brComponent="attribution"
            >
            </ng-container>
            <div
              *ngIf="page && !sectionsToShow.attribution?.populate"
              class="product-detail-layout__skeleton-space"
            >
              <eds-progress-spinner
                [isHide]="false"
                [ifLoadingText]="true"
                [loadingText]="'products.loading' | translate"
                spinnerName="ProductAttributionSpinner"
              ></eds-progress-spinner>
            </div>
          </div>
        </div>
      </div>
    </section>
  </eds-panel>

  <!-- Portfolio -->
  <eds-panel
    [theme]="sectionsToShow.portfolio?.isOddSection ? 'grey' : 'basic'"
    *ngIf="sectionsToShow.portfolio?.display"
  >
    <section
      id="portfolio"
      class="product-detail-layout__portfolio"
      edsGrid
      edsSpacing="xl"
      edsPadding
      edsPaddingTop="xl"
    >
      <div class="container container--wide">
        <!-- Portfolio Statistics -->
        <div edsRow>
          <div edsCol>
            <eds-title
              [title]="'products.fund-tab-portfolio' | translate: fundId"
              [level]="2"
              edsSpacing="lg"
              size="h2"
              theme="primary"
            ></eds-title>
          </div>
        </div>

        <!-- Preview -->
        <ng-container *ngIf="page && isEditMode">
          <ng-container brComponent="portfolio-statistics"></ng-container>
          <eds-title
            [title]="
              'products.portfolio-allocations-subheading' | translate: fundId
            "
            edsSpacing="md"
            size="h4"
          ></eds-title>
          <ng-container brComponent="portfolio-breakdowns"></ng-container>
          <eds-title
            [title]="
              'products.portfolio-holdings-subheading' | translate: fundId
            "
            edsSpacing="md"
            size="h4"
          ></eds-title>
          <ng-container brComponent="portfolio-holdings"></ng-container>
        </ng-container>
        <!-- /Preview -->

        <!-- Live -->
        <ng-container *ngIf="page && !isEditMode">
          <ng-container *ngIf="sectionsToShow.portfolio?.populate">
            <ng-container brComponent="portfolio-statistics"></ng-container>
            <!-- Allocations Section -->
            <ng-container *ngIf="portfolioAllocationsComponents.length > 0">
              <div edsRow edsSpacing="md">
                <div edsCol>
                  <eds-section-header [level]="3" size="h3" edsSpacing="lg">
                    {{
                      "products.portfolio-allocations-subheading"
                        | translate: fundId
                    }}
                  </eds-section-header>

                  <ng-container
                    *ngIf="portfolioAllocationsComponents.length === 1"
                    [brComponent]="portfolioAllocationsComponents[0]"
                  ></ng-container>

                  <eds-tabs
                    *ngIf="portfolioAllocationsComponents.length > 1"
                    [followFocus]="true"
                    [isNavigation]="true"
                    [darkBackground]="sectionsToShow.portfolio?.isOddSection"
                    [cacheActive]="true"
                    edsPadding
                    edsPaddingBottom="lg"
                    [fullWidth]="true"
                    dropdownTheme="handheld"
                  >
                    <eds-tab
                      *ngFor="
                        let portfolioAllocationsComponent of portfolioAllocationsComponents
                      "
                      [tabId]="portfolioAllocationsComponent.tabId"
                      [heading]="
                        portfolioAllocationsComponent.tabLabelKey
                          | translate: fundId
                      "
                      trackBy:componentId
                      (selected)="handlePortfolioTabSelection()"
                    >
                      <ng-container
                        [brComponent]="portfolioAllocationsComponent"
                      ></ng-container>
                    </eds-tab>
                  </eds-tabs>
                </div>
              </div>
            </ng-container>

            <!-- Holdings Section -->
            <ng-container *ngIf="portfolioHoldingsComponents.length > 0">
              <div edsRow edsSpacing="md">
                <div edsCol>
                  <eds-section-header [level]="3" size="h3" edsSpacing="md">
                    {{
                      "products.portfolio-holdings-subheading"
                        | translate: fundId
                    }}
                  </eds-section-header>

                  <ng-container
                    *ngIf="portfolioHoldingsComponents.length === 1"
                    [brComponent]="portfolioHoldingsComponents[0]"
                  ></ng-container>

                  <eds-tabs
                    *ngIf="portfolioHoldingsComponents.length > 1"
                    [followFocus]="true"
                    [isNavigation]="true"
                    [cacheActive]="true"
                    [darkBackground]="
                      sectionsToShow.portfolio?.isOddSection ? true : false
                    "
                    [cacheActive]="true"
                    edsPadding
                    edsPaddingBottom="lg"
                    [fullWidth]="true"
                    dropdownTheme="handheld"
                  >
                    <eds-tab
                      *ngFor="
                        let portfolioHoldingsComponent of portfolioHoldingsComponents
                      "
                      [tabId]="portfolioHoldingsComponent.tabId"
                      [heading]="
                        portfolioHoldingsComponent.tabLabelKey
                          | translate: fundId
                      "
                      (selected)="handlePortfolioTabSelection()"
                    >
                      <ng-container
                        [brComponent]="portfolioHoldingsComponent"
                      ></ng-container>
                    </eds-tab>
                  </eds-tabs>
                </div>
              </div>
            </ng-container>
          </ng-container>
          <div
            *ngIf="!sectionsToShow.portfolio?.populate"
            class="product-detail-layout__skeleton-space"
          >
            <eds-progress-spinner
              [isHide]="false"
              [ifLoadingText]="true"
              [loadingText]="'products.loading' | translate"
              spinnerName="ProductPortfolioSpinner"
            ></eds-progress-spinner>
          </div>
        </ng-container>
      </div>
    </section>
  </eds-panel>

  <!-- Distributions -->
  <eds-panel
    [theme]="sectionsToShow.distributions?.isOddSection ? 'grey' : 'basic'"
    *ngIf="page && (isEditMode || sectionsToShow.distributions?.display)"
  >
    <section
      id="distributions"
      class="product-detail-layout__distributions"
      edsGrid
      edsSpacing="xl"
      edsPadding
      edsPaddingTop="xl"
    >
      <div class="container container--wide">
        <div edsRow>
          <div edsCol class="product-detail-layout__distribution-layout">
            <eds-title
              *ngIf="!isLitPreview"
              [title]="'products.fund-tab-distributions' | translate: fundId"
              [level]="2"
              edsSpacing="lg"
              size="h2"
              theme="primary"
            ></eds-title>

            <ng-container *ngIf="page && !isEditMode">
              <eds-tabs
                *ngIf="
                  sectionsToShow.distributions?.populate &&
                  distributionComponents.length > 1
                "
                [followFocus]="true"
                [isNavigation]="true"
                [darkBackground]="
                  sectionsToShow.distributions?.isOddSection ? true : false
                "
                [cacheActive]="true"
                edsPadding
                edsPaddingBottom="lg"
                [fullWidth]="true"
                dropdownTheme="handheld"
              >
                <eds-tab
                  *ngFor="let distributionComponent of distributionComponents"
                  [tabId]="distributionComponent.tabId"
                  [heading]="
                    distributionComponent.tabLabelKey | translate: fundId
                  "
                >
                  <ng-container
                    [brComponent]="distributionComponent"
                  ></ng-container>
                </eds-tab>
              </eds-tabs>

              <ng-container
                *ngIf="
                  sectionsToShow.distributions?.populate &&
                  distributionComponents.length === 1
                "
                [brComponent]="distributionComponents[0]"
              ></ng-container>
              <div
                *ngIf="!sectionsToShow.distributions?.populate"
                class="product-detail-layout__skeleton-space"
              >
                <eds-progress-spinner
                  [isHide]="false"
                  [ifLoadingText]="true"
                  [loadingText]="'products.loading' | translate"
                  spinnerName="ProductDistributionsSpinner"
                ></eds-progress-spinner>
              </div>
            </ng-container>

            <!-- Preview -->
            <ng-container
              *ngIf="page && isEditMode"
              brComponent="distributions"
            ></ng-container>
          </div>
        </div>
      </div>
    </section>
  </eds-panel>

  <!-- Pricing -->
  <eds-panel
    [theme]="sectionsToShow.pricing?.isOddSection ? 'grey' : 'basic'"
    *ngIf="sectionsToShow.pricing?.display"
  >
    <section
      edsGrid
      edsSpacing="xl"
      id="pricing"
      class="product-detail-layout__pricing"
      edsPadding
      edsPaddingTop="xl"
    >
      <div class="container container--wide">
        <div edsRow>
          <div edsCol>
            <eds-title
              [title]="'products.fund-tab-pricing' | translate: fundId"
              [level]="2"
              edsSpacing="lg"
              size="h2"
              theme="primary"
            ></eds-title>

            <ng-container *ngIf="page && !isEditMode">
              <eds-tabs
                *ngIf="
                  sectionsToShow.pricing?.populate &&
                  pricingComponents.length > 1
                "
                [followFocus]="true"
                [isNavigation]="true"
                [cacheActive]="true"
                edsPadding
                edsPaddingBottom="lg"
                [fullWidth]="true"
                dropdownTheme="handheld"
              >
                <eds-tab
                  *ngFor="let pricingComponent of pricingComponents"
                  [tabId]="pricingComponent.tabId"
                  [heading]="pricingComponent.tabLabelKey | translate: fundId"
                  (selected)="handlePricingTabSelection()"
                >
                  <ng-container [brComponent]="pricingComponent"></ng-container>
                </eds-tab>
              </eds-tabs>

              <ng-container
                *ngIf="
                  sectionsToShow.pricing?.populate &&
                  pricingComponents.length === 1
                "
                brComponent="pricing"
              >
              </ng-container>
              <div
                *ngIf="!sectionsToShow.pricing?.populate"
                class="product-detail-layout__skeleton-space"
              >
                <eds-progress-spinner
                  [isHide]="false"
                  [ifLoadingText]="true"
                  [loadingText]="'products.loading' | translate"
                  spinnerName="ProductPricingSpinner"
                ></eds-progress-spinner>
              </div>
            </ng-container>

            <ng-container *ngIf="page && isEditMode" brComponent="pricing">
            </ng-container>
          </div>
        </div>
      </div>
    </section>
  </eds-panel>

  <!-- Commentary -->
  <eds-panel
    [theme]="sectionsToShow.commentary?.isOddSection ? 'grey' : 'basic'"
    *ngIf="sectionsToShow.commentary?.display"
  >
    <section
      edsSpacing="xl"
      id="commentary"
      class="product-detail-layout__commentary"
      edsGrid
      edsPadding
      edsPaddingTop="xl"
    >
      <div class="container container--wide">
        <div edsRow>
          <div edsCol>
            <eds-title
              [title]="'products.fund-tab-commentary' | translate: fundId"
              [level]="2"
              edsSpacing="lg"
              size="h2"
              theme="primary"
            ></eds-title>
            <ng-container *ngIf="page && !isEditMode">
              <ng-container
                *ngIf="sectionsToShow.commentary?.populate"
                brComponent="commentary"
              ></ng-container>
              <div
                *ngIf="!sectionsToShow.commentary?.populate"
                class="product-detail-layout__skeleton-space"
              >
                <eds-progress-spinner
                  [isHide]="false"
                  [ifLoadingText]="true"
                  [loadingText]="'products.loading' | translate"
                  spinnerName="ProductCommentarySpinner"
                ></eds-progress-spinner>
              </div>
            </ng-container>
            <ng-container *ngIf="page && isEditMode">
              <ng-container brComponent="commentary"></ng-container>
            </ng-container>
          </div>
        </div>
      </div>
    </section>
  </eds-panel>

  <!-- Press Releases -->
  <!-- TODO: this option needs added to tabsets -->
  <eds-panel
    [theme]="sectionsToShow['press-releases']?.isOddSection ? 'grey' : 'basic'"
    *ngIf="sectionsToShow['press-releases']?.display"
  >
    <section
      edsSpacing="xl"
      id="press-releases"
      class="product-detail-layout__press-releases"
      edsGrid
      edsPadding
      edsPaddingTop="xl"
    >
      <div class="container container--wide">
        <div edsRow>
          <div edsCol>
            <eds-title
              [title]="'products.fund-tab-press-releases' | translate: fundId"
              [level]="2"
              edsSpacing="lg"
              size="h2"
              theme="primary"
            ></eds-title>
            <ng-container *ngIf="page && !isEditMode">
              <ng-container
                *ngIf="sectionsToShow['press-releases']?.populate"
                brComponent="press-releases"
              ></ng-container>
              <div
                *ngIf="!sectionsToShow['press-releases']?.populate"
                class="product-detail-layout__skeleton-space"
              >
                <eds-progress-spinner
                  [isHide]="false"
                  [ifLoadingText]="true"
                  [loadingText]="'products.loading' | translate"
                  spinnerName="ProductPressReleasesSpinner"
                ></eds-progress-spinner>
              </div>
            </ng-container>
            <ng-container *ngIf="page && isEditMode">
              <ng-container brComponent="press-releases"></ng-container>
            </ng-container>
          </div>
        </div>
      </div>
    </section>
  </eds-panel>

  <!-- Documents -->
  <eds-panel
    class="print-hidden"
    [theme]="sectionsToShow.documents?.isOddSection ? 'grey' : 'basic'"
    *ngIf="sectionsToShow.documents?.display"
  >
    <section
      id="documents"
      class="product-detail-layout__documents"
      edsGrid
      edsPadding
      edsPaddingTop="md"
    >
      <div edsRow>
        <div edsCol>
          <eds-title
            *ngIf="!isLitPreview"
            [title]="'products.fund-tab-documents' | translate"
            [level]="2"
            size="h2"
            theme="primary"
            edsSpacing="lg"
          ></eds-title>
          <ng-container brComponent="documents"></ng-container>
        </div>
      </div>
    </section>
  </eds-panel>

  <!-- Marketing Content -->
  <section
    edsGrid
    *ngIf="page && !isLitPreview && (isEditMode || hasMarketingContent)"
    edsPadding
    edsPaddingTop="xl"
  >
    <div class="container container--wide">
      <section
        id="marketing-content"
        class="product-detail-layout__marketing-content"
        edsSpacing="xl"
      >
        <div edsRow>
          <div edsCol>
            <eds-title
              [title]="'products.fund-tab-marketing' | translate"
              [level]="2"
              edsSpacing="lg"
              size="h2"
              theme="primary"
            ></eds-title>

            <ng-container brComponent="marketing-content"></ng-container>
          </div>
        </div>
      </section>
    </div>
  </section>

  <!-- Similar Product -->

  <section
    id="related-products"
    class="product-detail-layout__attribution"
    edsGrid
    edsSpacing="xl"
    *ngIf="sectionsToShow['related-products']?.display"
  >
    <div class="container container--wide">
      <ng-container brComponent="related-products"> </ng-container>
    </div>
  </section>

  <!-- Caveats -->
  <section edsGrid edsSpacing="xl">
    <div edsRow>
      <div edsCol>
        <ng-container brComponent="caveats"></ng-container>
      </div>
    </div>
  </section>
</ng-container>
